import { createRoot } from "react-dom/client";

import { ClarityTrackerLoader } from '@shared/clarity/ClarityTrackerLoader';

import CreateProfile from './CreateProfile';
import { getInvitationId } from './invitation';

export default class DeviseConfirmationsShow {
  init() {
    const container = document.querySelector('#profile-confirmation')

    if (container) {
      const root = createRoot(container);

      const invitationId = getInvitationId();

      const props = {
        skipBusinessStep: container.dataset.skipBusinessStep === 'true',
        countries: JSON.parse(container.dataset.countries || '[]').map((c) => ({
          id: c.value,
          alpha2Code: c.value,
          title: c.label,
        })),
      }

      root.render(
        <>
          <ClarityTrackerLoader />
          <CreateProfile countries={props.countries} skipBusinessStep={props.skipBusinessStep} invitationId={invitationId} />
        </>
      );
    }
  }
}

window.App.Pages = window.App.Pages || {}
window.App.Pages.DeviseConfirmationsShow = DeviseConfirmationsShow
